import { Button } from '@coop/components';
import classnames from 'classnames';

import Heading from '../Heading';
import styles from './ListBlock.module.scss';

interface ListBlockHeaderProps {
    id?: string;
    headingProps?: React.ComponentPropsWithoutRef<typeof Heading>;
    linkText?: string;
    linkUrl?: string;
}

/**
 * Old header
 */
const ListBlockHeader = ({
    id,
    headingProps,
    linkText,
    linkUrl,
    children,
}: React.PropsWithChildren<ListBlockHeaderProps>) => {
    const hasHeaderText = !!children;
    const hasLink = linkText && linkUrl;

    return (
        <div
            className={classnames(
                'u-flex u-flexJustifySpaceBetween u-flexAlignCenter',
                (hasHeaderText || hasLink) && 'u-paddingBxsm',
            )}
        >
            <div style={{ width: '100%' }}>
                {hasHeaderText && (
                    <Heading
                        id={id}
                        className="u-marginAz"
                        element={headingProps?.element || 'h2'}
                        stylingElement={headingProps?.stylingElement || 'h4'}
                        color={headingProps?.color || 'black'}
                        alignment={headingProps?.alignment || 'start'}
                    >
                        {children}
                    </Heading>
                )}
            </div>

            {hasLink && (
                <a className="Link Link--green u-flexShrinkNone" href={linkUrl}>
                    {linkText}
                </a>
            )}
        </div>
    );
};

export const BlockHeader = ({
    linkText,
    linkUrl,
    headingProps,
    children,
    id,
}: React.PropsWithChildren<ListBlockHeaderProps>) => {
    return (
        !!children && (
            <div className={styles.HeaderContainer}>
                {linkText && linkUrl && (
                    <Button size={32} theme="white" asChild className={styles.Link}>
                        <a href={linkUrl}>{linkText}</a>
                    </Button>
                )}
                <Heading
                    id={id}
                    className={styles.Header}
                    element={headingProps?.element || 'h2'}
                    stylingElement={headingProps?.stylingElement || 'h2'} // we do not have exactly the same h2 secondary font, we override this for now with styles.Header
                    color={headingProps?.color || 'darkGreen'}
                    alignment={headingProps?.alignment || 'center'}
                    fontFamilySecondary
                >
                    {children}
                </Heading>
            </div>
        )
    );
};

export default ListBlockHeader;
